import React, {Suspense, lazy} from "react";
import {
	Outlet,
	Route,
	createRoutesFromElements,
	isRouteErrorResponse,
	useRouteError,
	Routes
} from "react-router-dom";
import PrivateLayout from "../Layout/Private";
import NoFoundPage from "../pages/NoFound";
import InternalError from "../pages/Error";
import TeamSettings from '../pages/TeamSettings';
import GlobalInventoryReport from "../pages/GlobalInventoryReport";
import VariableQuotaLedger from "../pages/VariableQuotaLedger";
import Settings from '../pages/Settings';
import {ROUTES} from "./routes";
import RequiredAuth from "../component/SecureRoute";
import { LoginCallback } from '@okta/okta-react';

const ProvidersLayout = () => {
	return (
		<Suspense>
			<Outlet />
		</Suspense>
	);
};

const PrivateRootErrorElement = () => {
	const error = useRouteError();

	if (isRouteErrorResponse(error)) {
		if (error.status === 404) {
			return <NoFoundPage />;
		}
		return <InternalError />;
	}

	return null;
};

const Home = lazy(() => import("../pages/Home"));

const protected_routes = <Routes>
	<Route
		element={<ProvidersLayout />}
		errorElement={<PrivateRootErrorElement />}
	>
		<Route element={<RequiredAuth/>}>
			<Route element={<PrivateLayout />}>
				<Route path={ROUTES.HOME} element={<Home />} />
				<Route path={ROUTES.GLOBAL_INVENTORY_REPORT} element={<GlobalInventoryReport />} />
				<Route path={ROUTES.TEAM_SETTINGS} element={<TeamSettings />} />
				<Route path={ROUTES.MATTERS} element={<></>} />
				<Route path={ROUTES.VARIABLE_QUOTA_LEDGER} element={<VariableQuotaLedger />} />
				<Route path={ROUTES.BASIC_SETTINGS} element={<Settings advanced={false}/>} />
				<Route path={ROUTES.ADVANCED_SETTINGS} element={<Settings advanced={true}/>} />

			</Route>
		</Route>
		<Route path={"/callback"} element={<LoginCallback />} />
	</Route>
	</Routes>;

export default protected_routes;